/* global __APP_VERSION__ */
import { datadogRum } from '@datadog/browser-rum';
import { ddBeforeSend } from './piiScrubber';

export const InitDatadog = () => {
  datadogRum.init({
    // Authentication
    applicationId: window.datadogRumApplicationId,
    clientToken: window.datadogRumClientToken,

    // Privacy
    defaultPrivacyLevel: 'mask-user-input',
    enablePrivacyForActionName: true,
    trackingConsent: 'granted',

    // Data collection
    actionNameAttribute: 'data-dd-action-name',
    beforeSend: ddBeforeSend,
    env:
      window.location.hostname === 'lifeline.blinkit.com'
        ? 'production'
        : 'preprod',
    service: 'delivery-lifeline-dashboard',
    sessionSampleRate: 20,
    trackFeatureFlagsForEvents: ['action', 'resource', 'long_task', 'vital'],
    trackResourceHeaders: false, //to be changes to true later after proper checking
    trackResources: true, //to be reviewed for api designs
    trackUserInteractions: true,
    trackViewsManually: true,
    version: __APP_VERSION__,

    // Session replay
    sessionReplaySampleRate: 5,
    startSessionReplayRecordingManually: false, // to be enabled for better privacy and record just a specific flow

    // Tracing
    allowedTracingUrls: [], //TBA
    propagateTraceBaggage: false, //TBR
    traceSampleRate: 10,
    traceContextInjection: 'sampled',

    // Profiling
    profilingSampleRate: 10,

    // Session persistence
    trackSessionAcrossSubdomains: false,
    usePartitionedCrossSiteSessionCookie: true,
    useSecureSessionCookie: true,

    // transport
    compressIntakeRequests: true,
    site: 'datadoghq.com',
  });
};
